import { OnboardingFormFields } from '@Types/index.ts';
import type { FormFieldErrors } from '../../../types/error.types.ts';
export const getFormFieldsModel = () => {
  const formList = Object.values(OnboardingFormFields);
  return formList.reduce((acc, key) => ({ ...acc, [key]: '' }), {}) as FormFieldErrors;
};
